// extracted by mini-css-extract-plugin
export default {"table":"Table_table__+GdwM","increase2":"Table_increase2__LhrjY","table2":"Table_table2__Tjfr-","tablehead":"Table_tablehead__Vn4c8","col":"Table_col__WRO0e"};